import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb, Modal } from 'semantic-ui-react'
import { MainBodyContent } from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { ShortListDetailContainer } from './styled'
import { shortListPath } from 'routes'
import DocumentStep from 'routes/ProcurementSystem/Shared/DocumentStep'
import { ProcurementContainer, ProcurementBody } from 'routes/ProcurementSystem/styled'
import { getShortListDetail, getWorkflow, updateShortList, clearFormData, getPreQFormulas } from 'ducks/shortList'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import Committee from '../Forms/Committee'
import ShortListPart from '../Forms/ShortListPart'
import ShortListFullDetail from '../Forms/FullDetailPart'
import PrequalificationPart from '../Forms/PrequalificationPart'
import CommitteeApprove from '../Forms/CommitteeApprove'
import SubmitForm from '../Forms/SubmitForm'
import { validateCommitteeForm, validatePreQForm, validateVendorForm, convertVendorDataToPQ, updatePqValueFromVendor } from '../attributeData'
import SLStep from './SLStep'

import r from 'reactotron-react-js'

const ShortListDetail = (props) => {
  const { valueForm, change, updateShortList, history, shortList, workflow, members, handleSubmit, preQFormulas, isDetail = true, } = props
  const [isSubmit, setIsSubmit] = useState(false)

  const [formStep, setFormStep] = useState(1)
  const [maxStep, setMaxStep] = useState(1)

  const [showValidationFail, setShowValidationFail] = useState(false)

  const onChangeForm = (formIndex) => {
    setFormStep(formIndex)
    window.scrollTo(0, 0)
  }

  useEffect(() => {
    props.getShortListDetail(props.match.params.id, props.history)
    props.getWorkflow(props.match.params.id)

    props.getAllMembers(isDetail)
    // props.getHrmsMembers(isDetail)

    if (!preQFormulas.data.length && !preQFormulas.loading) {
      props.getPreQFormulas()
    }

    return () => {
      props.clearFormData()
    }
  }, [])

  const onSubmitCreateForm = (values) => {
    var errors = validate(values)

    if (Object.keys(errors).length) {
      scrollToFirstValidateFailElement(errors)
      throw new SubmissionError(errors)
    } else {
      updateShortList(values, isSubmit, history)
    }
  }

  const isRequirePQ = () => {
    const workOptions = props.works.data
    const { works } = valueForm

    var requirePQ = false

    if (works) {
      (works || []).forEach(w => {
        var workOpt = workOptions.find(wo => wo.value === w)
  
        if (workOpt && workOpt.requirePq) {
          requirePQ = true
        }
      })
    }

    return requirePQ
  }

  const showFullDetail = () => {
    if (shortList.sn && (shortList.actions || []).length !== 0) {
      if (shortList.statusActivity === 'Procurement') {
        return false
      } else {
        return true
      }
    }

    return true
  }

  const isDisplay = () => {
    if (valueForm.status !== 0 && valueForm.status !== undefined && valueForm.status !== null) {
      return !(valueForm.sn !== undefined && valueForm.sn !== null && valueForm.sn !== '')
    } else {
      return true
    }
  }

  const onClickNext = () => {
    const nextStep = () => {
      setFormStep(formStep + 1)
      window.scrollTo(0, 0)
    }

    var errors = {}

    if (formStep === 1) {
      // VENDOR STEP
      var vendors = valueForm.vendors || []
      errors = validateVendorForm(vendors, errors)

      if (Object.keys(errors).length) {
        scrollToFirstValidateFailElement(errors)
        throw new SubmissionError(errors)
      } else {
        if (isRequirePQ()) {
          // TO DO :: Check vendor data and pq data generate or update or remove pq data by vendor data
          var pqs = valueForm.pqs || []
          var newPqs = []
          vendors.forEach((v, i) => {
            var pqIndex = pqs.findIndex(pq => pq.vendorCode === v.vendorCode)
            if (pqIndex !== -1) {
              var oldData = { ...pqs[pqIndex] }
              oldData = updatePqValueFromVendor(oldData, v, preQFormulas)
              newPqs.push(oldData)
            } else {
              var pqData = convertVendorDataToPQ(v, preQFormulas)
              newPqs.push(pqData)
            }
          })

          change('pqs', newPqs)
        }

        nextStep()
      }
    } else if ((formStep === 2 && !isRequirePQ()) || (formStep === 3 && isRequirePQ())) {
      // COMMITTEE STEP
      errors = validateCommitteeForm(valueForm.committees || [], {})
      if (Object.keys(errors).length) {
        throw new SubmissionError(errors)
      } else {
        nextStep()
      }
    } else if (formStep === 2 && isRequirePQ()) {
      // PRE-Q STEP
      errors = validatePreQForm(valueForm.pqs || [], {})
      if (Object.keys(errors).length) {
        scrollToFirstValidateFailElement(errors)
        throw new SubmissionError(errors)
      } else {
        nextStep()
      }
    } else {
      nextStep()
    }
  }

  const isCommittee = () => {
    const { statusActivity, sn } = valueForm

    return statusActivity === 'Committee' && sn !== null && sn !== undefined && sn !== ''
  }
  
  return (
    <MainBodyContent 
      headerTitle={`Short List - ${valueForm.documentNumber}`}
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'SL', content: 'Short List', link: true, onClick: () => props.history.push(shortListPath) },
              { key: 'SLCreate', content: valueForm.documentNumber || 'Detail', active: true }
            ]
          }
        />
      }
      accessoriesHeader= {
        <div className='cardHeaderActions'>
        </div>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <DocumentStep documentDetail={shortList} approvers={workflow.data} />
          {
            isCommittee() ?
              <CommitteeApprove valueForm={valueForm} handleSubmit={handleSubmit} change={change} history={props.history} /> :
            showFullDetail() ? 
              <form>
                <ShortListFullDetail 
                  valueForm={valueForm} 
                  change={change} 
                  handleSubmit={handleSubmit} 
                  members={members} 
                  history={props.history} 
                  isRequirePQ={isRequirePQ()} 
                  businessPartners={props.businessPartners} 
                  companies={props.companies}
                  projects={props.projects}
                  typeOfTenders={props.typeOfTenders}
                  works={props.works}
                />
              </form> :
              <ShortListDetailContainer>
                <form onSubmit={props.handleSubmit((values) => onSubmitCreateForm(values))}>
                  <SLStep activeStep={formStep - 1} setFormStep={onChangeForm} maxStep={maxStep} requirePQ={isRequirePQ()} />
                  {formStep === 1 ? <ShortListPart isDisplay={isDisplay()} generalDisplay={true} valueForm={valueForm} change={change} /> : null}
                  {
                    formStep === 2 ? 
                      isRequirePQ() ? 
                        <PrequalificationPart isDisplay={isDisplay()} valueForm={valueForm} change={change} /> : 
                        <Committee valueForm={valueForm} change={change} isDisplay={isDisplay()} members={members} showCollapse={true} /> : 
                        null
                  }
                  {
                    formStep === 3 ? 
                      isRequirePQ() ?  
                          <Committee valueForm={valueForm} change={change} isDisplay={isDisplay()} members={members} showCollapse={true} /> : 
                          <SubmitForm valueForm={valueForm} change={change} handleSubmit={handleSubmit} history={props.history} /> :
                          null
                  }
                  {formStep === 4 ? <SubmitForm valueForm={valueForm} change={change} handleSubmit={handleSubmit} history={props.history} /> : null}
                  <div className='btnContainer'>
                    <div className='left'>
                      {
                        formStep > 1 ? 
                          <Button
                            type='button'
                            content='Back'
                            color='blue'
                            icon='angle left'
                            labelPosition='left'
                            style={{ marginRight: '5px' }}
                            onClick={() => setFormStep(formStep - 1)}
                          /> : null
                      }
                    </div>
                    <div className='right'>
                      {
                        formStep < (isRequirePQ() ? 4 : 3) ?
                          <Button
                            type='button'
                            content='Next'
                            color='blue'
                            icon='angle right'
                            labelPosition='right'
                            style={{ marginRight: '5px' }}
                            onClick={props.handleSubmit((values) => onClickNext())}
                          /> : null
                      }
                    </div>
                  </div>
                </form>
              </ShortListDetailContainer>
          }
        </ProcurementBody>
        <Modal open={showValidationFail} size='small'>
          <Modal.Content>
            <p>
              Please select committee!
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              type='button'
              content='Close'
              color='red'
              icon='times'
              labelPosition='right'
              style={{ marginRight: '5px' }}
              onClick={() => setShowValidationFail(false)}
            />
          </Modal.Actions>
        </Modal>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  const vf = getFormValues('formShortList')(state) || {}
  const sl = state.shortList.shortList.data

  return ({
    valueForm: vf,
    shortList: sl,
    workflow: state.shortList.workflow,
    members: {
      data: state.member.members,
      loading: state.member.memberLoading
    },
    businessPartners: state.options.businessPartners,
    companies: state.options.companies,
    projects: state.goa.projects,
    projectCompanyLoading: state.goa.projectCompanyLoading,
    projectLoading: state.goa.projectLoading,
    typeOfTenders: state.options.typeOfTenders,
    works: state.options.works,
    preQFormulas: state.shortList.preQFormulas,
    initialValues: {
      id: sl.id,
      status: sl.status,
      statusActivity: sl.statusActivity,
      title: vf.title || sl.title || null,
      documentDate: vf.documentDate || sl.documentDate || null,
      documentNumber: vf.documentNumber || sl.documentNumber || null,
      companyCode: vf.companyCode || sl.companyCode || null,
      typeOfTender: vf.typeOfTender || sl.typeOfTender || null,
      works: vf.works || sl.works || null,
      projectId: vf.projectId || sl.projectId || null,
      requesterUser: vf.requesterUser || sl.requesterUser || null,
      createdBy: vf.createdBy || sl.createdBy || null,
      effectiveDate: vf.effectiveDate || sl.effectiveDate || null,
      draftBudget: vf.draftBudget || sl.draftBudget || null,
      projectStartTime: vf.projectStartTime || sl.projectStartTime || null,
      projectEndTime: vf.projectEndTime || sl.projectEndTime || null,
      remark: vf.remark || sl.remark || null,
      vendors: vf.vendors || sl.vendors || null,
      pqs: vf.pqs || sl.pqs || null,
      committees: vf.committees || sl.committees || null,
      attachment01: vf.attachment01 || sl.attachment01 || null,
      sn: sl.sn,
      actions: sl.actions,
      evaluations: vf.evaluations || sl.evaluations || null,
      SL01: vf.SL01 || null
    }
  })
}

const mapDispatchToProps = {
  getShortListDetail,
  getWorkflow,
  updateShortList,
  clearFormData,
  getHrmsMembers,
  getPreQFormulas,
  getAllMembers
}

const validate = (values) => {
  let errors = {}

  return errors
}

const ShortListDetailForm = reduxForm({
  form: 'formShortList',
  enableReinitialize: true
})(ShortListDetail)

export default connect(mapStateToProps, mapDispatchToProps)(ShortListDetailForm)